import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loader", "frameInitiate", "frame"]

  connect() {
    document.addEventListener("turbo:before-fetch-request", this.handleStart)
    document.addEventListener("turbo:frame-load", this.handleEnd)
    document.addEventListener("turbo:render", this.handleEnd)
  }

  disconnect() {
    document.removeEventListener("turbo:before-fetch-request", this.handleStart)
    document.removeEventListener("turbo:frame-load", this.handleEnd)
    document.removeEventListener("turbo:render", this.handleEnd)
  }

  // Many pages wire the controller without some of its targets: listening on
  // the document, it would throw on every Turbo request (live filters send
  // many) instead of doing nothing.
  handleStart = (event) => {
    if (!this.hasLoaderTarget || !this.hasFrameInitiateTarget) return
    if (event.target.id === this.frameInitiateTarget.id) {
      this.loaderTarget.classList.remove("hidden")
    }
  }

  handleEnd = (event) => {
    if (!this.hasLoaderTarget || !this.hasFrameTarget) return
    if (event.target.id === this.frameTarget.id) {
      this.loaderTarget.classList.add("hidden")
    }
  }
}
